import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    primaryColor:   String,
    secondaryColor: String,
    tertiaryColor:  String,
    background:     String,
    previewUrl:     String,
    designId:       Number,
  }

  static targets = [
    "bgPrimaryColor", "textPrimaryColor", "primaryColorInput",
    "bgSecondaryColor", "textSecondaryColor", "secondaryColorInput",
    "bgTertiaryColor", "textTertiaryColor", "tertiaryColorInput",
    "castPreview", "bgButton", "bgInput", "hashtagInput", "selectInput"
  ]

  connect() {
    this.primaryColorInputTarget.value = this.primaryColorValue;
    this.secondaryColorInputTarget.value = this.secondaryColorValue;
    this.tertiaryColorInputTarget.value = this.tertiaryColorValue;
  }

  setBackground(event) {
    const bgUrl = event.target.dataset.background;
    const bgId = event.target.dataset.id;

    this.castPreviewTarget.style.backgroundImage = `url(${bgUrl})`;
    this.bgInputTarget.value = bgId;
  }
  
  async setPreview(event) {
    const params = new URLSearchParams({
      style_name:       event.target.value,
      primary_color:    this.primaryColorInputTarget.value,
      secondary_color:  this.secondaryColorInputTarget.value,
      tertiary_color:   this.tertiaryColorInputTarget.value,
    })

    if (this.hasDesignIdValue) params.set('design_id', this.designIdValue)

    const response = await fetch(`${this.previewUrlValue}?${params}`, {
      headers: { Accept: 'text/html' }
    })

    if (response.ok) this.castPreviewTarget.innerHTML = await response.text()
  }

  setPrimaryColor(e) {
    this.bgPrimaryColorTargets.map(target => { target.style.backgroundColor = e.target.value });
    this.textPrimaryColorTargets.map(target => { target.style.color = e.target.value });
  }

  setSecondaryColor(e) {
    this.bgSecondaryColorTargets.map(target => { target.style.backgroundColor = e.target.value });
    this.textSecondaryColorTargets.map(target => { target.style.color = e.target.value });
  }

  setTertiaryColor(e) {
    this.bgTertiaryColorTargets.map(target => { target.style.backgroundColor = e.target.value });
    this.textTertiaryColorTargets.map(target => { target.style.color = e.target.value });
  }

  toggleHastagInput(e) {
    if (e.target.value === "image_comments_portrait") {
      this.hashtagInputTarget.classList.remove("hidden");
    } else {
      this.hashtagInputTarget.classList.add("hidden");
    }
  }
}
